import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from 'vue';

interface IProps {
  text: string;
  bgColor: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomLegend',
  props: {
    text: {},
    bgColor: { default: '#ccffee' }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", null, [
    _createElementVNode("span", {
      class: "destac me-1",
      style: _normalizeStyle({ background: _ctx.bgColor })
    }, null, 4),
    _createTextVNode(" " + _toDisplayString(props.text), 1)
  ]))
}
}

})